import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const projectPublishHistorySelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectSelector(projectId),
      (project) => project?.publishHistory || null
    )
);
